import { Component, OnDestroy, OnInit } from '@angular/core'
import { StateServices } from '../../../../../services/state.services'

@Component({
    selector: 'app-modal-search-timline',
    templateUrl: './modal-search-timline.component.html',
    styleUrls: [
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        './modal-search-timline.component.css',
        '../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalSearchTimlineComponent implements OnInit, OnDestroy {

    dataSearchCharge: any
    isActive: any = 'hidden'
    arrCharge: any[] = []
    idStaff: any = undefined

    constructor(
        private stateServices: StateServices,
    ) {
    }

    ngOnInit() {
        this.dataSearchCharge = this.stateServices.changeEmittedStaffCharge$.subscribe(res => {
            if (res && res['action']) {
                this.idStaff = res['selected']
                this.isActive = res['action']
                this.arrCharge = res['data']
                if (this.arrCharge) {
                    this.arrCharge.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            }
        })
    }

    ngOnDestroy() {
        if(this.dataSearchCharge)
            this.dataSearchCharge.unsubscribe()
    }

    selectOption(item) {
        this.isActive = 'hidden'
        this.stateServices.emitChangeStaffCharge(null)
        const emitValueStaff = {}
        emitValueStaff['value'] = item
        this.stateServices.emitChangeValueStaffCharge(emitValueStaff)
    }

    closeModal() {
        this.isActive = 'hidden'
        this.stateServices.emitChangeStaffCharge(null)
    }

    getClassSelected(id) {
        if (this.idStaff && this.idStaff != '') {
            if (this.idStaff == id) {
                return true
            }
        }
        return false
    }

    getShowName(item) {
        let showName = ''
        if (item['firstName']) {
            showName += item['firstName'] + ' '
        }
        if (item['familyName']) {
            showName += item['familyName']
        }
        return showName
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/timeline/modal-search-timline/modal-search-timline.component.ts